import { useSearchParams } from "react-router";
import { cn } from "@/lib/cn";
import { BiometricsList } from "./biometrics/biometrics-list";
import { CategoriesPage } from "./categories";
import { LabsPage } from "./labs";
import { QuestionsPage } from "./questions/questions-page";
import { AssessmentVariantsPage } from "./assessment-variants";
import { PricesPage } from "./prices";

const TABS = [
  { key: "biomarkorer", label: "Biomarkører" },
  { key: "kategorier", label: "Kategorier" },
  { key: "labber", label: "Labber" },
  { key: "sporsmal", label: "Spørsmål" },
  { key: "analysevarianter", label: "Analysevarianter" },
  { key: "priser", label: "Priser" },
] as const;

type TabKey = (typeof TABS)[number]["key"];

export function CatalogPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = (searchParams.get("tab") as TabKey) || "biomarkorer";

  const setActiveTab = (tab: TabKey) => {
    setSearchParams({ tab }, { replace: true });
  };

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold">Katalog</h2>

      <div className="flex gap-1 border-b border-admin-card-border">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={cn(
              "px-4 py-2 text-sm font-medium transition-colors border-b-2 -mb-px cursor-pointer",
              activeTab === tab.key
                ? "border-admin-primary text-admin-primary"
                : "border-transparent text-admin-text-secondary hover:text-admin-text-primary hover:border-admin-card-border"
            )}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {activeTab === "biomarkorer" && <BiometricsList />}
      {activeTab === "kategorier" && <CategoriesPage />}
      {activeTab === "labber" && <LabsPage />}
      {activeTab === "sporsmal" && <QuestionsPage />}
      {activeTab === "analysevarianter" && <AssessmentVariantsPage />}
      {activeTab === "priser" && <PricesPage />}
    </div>
  );
}
